import { render } from "./ClientDetailsView.vue?vue&type=template&id=6e7f6eb8"
import script from "./ClientDetailsView.vue?vue&type=script&lang=js"
export * from "./ClientDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__